import { render, staticRenderFns } from "./ModalDisciplinas.vue?vue&type=template&id=081589a3&"
import script from "./ModalDisciplinas.vue?vue&type=script&lang=js&"
export * from "./ModalDisciplinas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports